// Public, reusable template settings. Installation identity, rollout assignment,
// notification recipients, experiment state and library metadata are not copied.
export const MAGNET_TEMPLATE_DEFAULT_APPEARANCE = Object.freeze({
  display_mode: 'inline', trigger: 'on_load', theme_mode: 'auto', theme_color: '#0072BA', home: false,
});
export const MAGNET_TEMPLATE_APPEARANCE_KEYS = Object.freeze([
  'title', 'subtitle', 'theme_color', 'display_mode', 'trigger', 'theme_mode',
  'launcher_label', 'logo_url', 'logo_fit', 'logo_scale', 'summary', 'summary_heading',
  'summary_confirm_label', 'home', 'welcome', 'actions', 'hide_launcher',
  'success_title', 'success_text', 'success_cta', 'input_placeholder', 'font',
  'theme_vars', 'inline_width', 'inline_height',
  'welcome_experience', 'visual_style', 'motion_style', 'message_style', 'presentation_style', 'launcher_style', 'launcher_hint', 'visitor_controls', 'home_title',
]);
const clone = value => value === undefined ? undefined : JSON.parse(JSON.stringify(value));
const object = value => value && typeof value === 'object' && !Array.isArray(value);

export function templateAppearance(source = {}, prefix = '') {
  return Object.fromEntries(MAGNET_TEMPLATE_APPEARANCE_KEYS
    .filter(key => Object.hasOwn(source, prefix + key))
    .map(key => {
      const value = source[prefix + key];
      // The original library seed used this spelling. Translate its intended
      // page-load behavior when copying; do not edit the published source row.
      return [key, key === 'trigger' && value === 'on_page_load' ? 'on_load' : clone(value)];
    }));
}

export function templatePackage(template) {
  const appearance = templateAppearance(object(template.appearance) ? template.appearance : {});
  return {
    ...Object.fromEntries(Object.entries(appearance).map(([key, value]) => [`mag_${key}`, value])),
    ...(template.marketing_excluded === true ? { mag_marketing_excluded: true } : {}),
    mag_macro_steps: clone(Array.isArray(template.steps) ? template.steps : []),
    ...(Object.hasOwn(template, 'routes') ? { mag_routes: clone(template.routes) } : {}),
  };
}

// One atomic definition PATCH to the new draft. Let the save API validate named
// routes; never silently drop an unsupported or malformed authored route.
export function templateChanges(template) {
  const body = { name: template.name, ...templateAppearance(template.appearance || {}), steps: clone(template.steps) };
  // Support requests use the existing operator policy. Templates may suggest
  // exclusion, never copy an account's delivery settings or opt it into marketing.
  if (template.marketing_excluded === true) body.marketing_excluded = true;
  if (Object.hasOwn(template, 'routes')) {
    if (!object(template.routes) || Object.hasOwn(template.routes, 'chat')) throw new Error('This template has an invalid named flow.');
    body.flows = { chat: clone(template.steps), ...clone(template.routes) };
  }
  return body;
}
